// extracted by css-extract-rspack-plugin
export default {"root":"vkHByU","icon":"dTDxi1","active-icon":"j3W_7G","activeIcon":"j3W_7G"};